enum IProgressStatus {
	Normal = 'normal',
	Exception = 'exception',
	Active = 'active',
	Success = 'success'
}

export default IProgressStatus;
